import { Fragment } from 'react';

import Select from '@common/components/Forms/components/Select';
import countryStatesList from './CountryStateList.json';
import Option from '@common/components/Forms/components/Option';

export const CountrySelect = ({
  id,
  field,
  name,
  label,
  touched,
  register,
  errors,
  country,
  dark = false,
  ...rest
}) => (
  <Select
    id={id}
    name={name}
    errors={errors}
    label={label}
    dark={dark}
    field={field}
    value={country}
    autoComplete="off"
    required={true}
    {...rest}
  >
    <Option disabled hidden value="" />
    {Object.keys(countryStatesList.country).map(countryCode => (
      <Fragment key={countryCode.toLowerCase()}>
        <Option
          value={countryCode.toLowerCase()}
          label={countryStatesList.country[countryCode]}
        />
      </Fragment>
    ))}
  </Select>
);
